import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-562bcbfd"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]

import { ref, withDefaults } from "vue";
import Paginator, { PageState } from "primevue/paginator";
import { get } from "@vueuse/core";
import { DEFAULT_PAGINATOR_ROWS } from "@/clinic/typings/constants/paginator";

type IPaginator = {
  rows: number;
  totalRecords: number;
  modelValue?: number;
  class?: string;
  paginatorId?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    rows: { default: DEFAULT_PAGINATOR_ROWS },
    totalRecords: null,
    modelValue: null,
    class: null,
    paginatorId: null
  },
  emits: ["paging", "update:modelValue"],
  setup(__props: any, { expose, emit: emits }) {

const props = __props as { rows: number, totalRecords: number, modelValue?: number, class?: string, paginatorId?: string };





const paging = (event: PageState) => {
  // idを正しく取得する方法に修正
  const id = props.paginatorId || "unknown";

  // PrimeVueのPageStateから直接firstの値を取得
  const newFirst = event.first;
  emits("update:modelValue", newFirst);
  emits("paging", id, event);
};

const pagination = ref<InstanceType<typeof Paginator> | null>(null);

const getPagination = () => get(pagination);

// eslint-disable-next-line no-undef
expose({
  getPagination,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex flex-row",
    id: __props.paginatorId
  }, [
    _createVNode(_unref(Paginator), {
      ref_key: "pagination",
      ref: pagination,
      rows: __props.rows,
      totalRecords: __props.totalRecords,
      first: __props.modelValue,
      class: _normalizeClass(`${props?.class || ''}`),
      onPage: paging
    }, null, 8, ["rows", "totalRecords", "first", "class"])
  ], 8, _hoisted_1))
}
}

})